<ng-container *ngIf="!isLoading">
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="form-row">
        <div class="form-group col-12">
          <label
            [class.font-weight-bold]="form.get('description')?.dirty"
            for="description"
          >
            {{ "headers.fastcr.risk_model.model" | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            [ngClass]="{
              'is-invalid':
                showValidationError && form.get('description')?.invalid
            }"
            class="form-control form-control-sm"
            formControlName="description"
            id="description"
            type="text"
          />
          <div
            class="text-danger"
            *ngIf="showValidationError && form.get('description')?.invalid"
          >
            {{ "messages.required" | translate }}
          </div>
        </div>
        <div class="form-group col-12">
          <label
            [class.font-weight-bold]="form.get('comment')?.dirty"
            for="comment"
          >
            {{ "headers.fastcr.risk_model.comment" | translate }}
          </label>
          <app-field-clear-button
            [formGroupRef]="form"
            [fieldName]="'comment'"
          ></app-field-clear-button>
          <input
            [ngClass]="{
              'is-invalid': showValidationError && form.get('comment')?.invalid
            }"
            class="form-control form-control-sm"
            formControlName="comment"
            id="comment"
            type="text"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label for="modelImages">
            {{ "headers.fastcr.risk_model.images" | translate }}
          </label>

          <app-core-image-slider
            #imageSlider
            *ngIf="!imagesLoaded || hasExistingImages"
            [entityType]="'risk_model'"
            [entityId]="targetIds[0]"
            [editable]="true"
            (imagesChange)="onSliderImagesChange($event)"
          ></app-core-image-slider>

          <ng-container *ngIf="imagesLoaded">
            <ng-container *ngIf="!hasExistingImages">
              <app-core-image-upload
                [multiple]="true"
                [showSaveHint]="true"
                (imagesUploaded)="onFormImagesUploaded($event)"
              ></app-core-image-upload>
            </ng-container>

            <ng-container *ngIf="hasExistingImages">
              <div class="text-center mt-2">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="openImageUploadModal()"
                >
                  <i class="la la-upload"></i>
                  {{ "core_image_upload.add_images" | translate }}
                </button>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </form>

    <!-- Image upload body template for the generic modal -->
    <ng-template #imageUploadBody>
      <app-core-image-upload
        #modalUploadComp
        [multiple]="true"
        (imagesUploaded)="onModalImagesUploaded($event)"
      ></app-core-image-upload>
    </ng-template>
  </div>

  <div class="modal-footer">
    <div class="form-group">
      <div class="col-12 d-flex justify-content-between">
        <button (click)="bsModalRef.hide()" class="btn btn-sm btn-light mr-2">
          <i class="la la-ban"></i>
          {{ "navigations.cancel" | translate }}
        </button>
        <button
          (click)="save()"
          [disabled]="isSubmitted"
          class="btn btn-sm btn-success"
        >
          <i *ngIf="!isSubmitted" class="la la-save"></i>
          <i *ngIf="isSubmitted" class="la la-spinner la-spin"></i>
          {{ "navigations.save" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
